<template>
<dv-full-screen-container>
<div class="app">
  <template v-if="timeLoading">
    <Header></Header>
    <div class="content-warp">
      <column-1></column-1>
      <column-2></column-2>
      <column-3></column-3>
      <column-4></column-4>
    </div>
  </template>
  <dv-loading v-else class="loading">演示模式...</dv-loading>
</div>
</dv-full-screen-container>
</template>

<script>
import Header from "./components/Header"
import Column1 from './components/column1/column1'
import Column2 from './components/column2/column2'
import Column3 from './components/column3/column3'
import Column4 from './components/column4/column4'

export default {
  name: "App",

  components: {
    Header,
    Column1,
    Column2,
    Column3,
    Column4
  },

  data () {
    return {
      timeLoading: false
    }
  },

  created () {
    setTimeout(() => {
      this.timeLoading = true
    }, 1000 * 2)
  }
}
</script>
 
<style lang="less">
.app {
  width: 3456px;
  height: 1096.8991px;
  height: 1080px;
  display: flex;
  flex-direction: column;
  background-image: url("~assets/image/background.png");
}

.content-warp {
  flex-grow: 1;
  display: flex;
  padding: 0 36px 37px 36px;
}

.loading {
  transform: scale(2);
  color: #fff;
}
</style>
